import { localImages } from './localImages';

export const addBookingsTab = ["Basic Details", "Cargo Details", "Routes", "Vehicles", "Container", "Address", "Documents"]
export const ClientTabs = ["Booking", "Trips", "Routes", "Commodities", "Payments", "Documents", "Other Details"];
export const BookingViewTabs = ["Trip Details", "Routes", "Vehicles", "Cargo", "Expenses", "Invoices", "Documents", "History"];
// export const BookingViewTabs = ["Trip Details", "Routes","Vehicles", "Drivers", "Commodities", "Payments", "Documents"];
export const TripTabs = ["AllTrips", "Pending", "On Going", "Holds", "Clearance Points", "Cancelled", "Completed"];
export const TripDetailstab = ["TripDetails", "Routes", "Vehicles", "Cargo", "Expenses", "Invoices", "Documents", "History"];
export const Clientformtab = ['Executive Details', 'Billing Details', 'Payment Details', 'Other Details', 'Document'];
export const TripFormTabs = ['Cargo Details', 'Route', 'Documents'];
export const VehicleTabs = ['Owner Details', 'Insurance Details', 'Address Details', 'Documents'];

export const images = [
    localImages.americanStyleTruck,
    localImages.semiTruckFact,
    localImages.semiTruckFact,
    localImages.truckTransport,
    localImages.truckTrailerSunset,
];
export const EmployeeFormTabs = ['Personal Details', 'Address Details', 'Bank Details', 'Documents'];
export const DriverFormTabs = ['Personal Details', 'Address Details', 'Bank Details', 'Documents'];